import { ReactNode, useEffect } from "react";

import { useAuth } from "~/components/react-auth";
import { useDatadogRUM } from "~/hooks/use-datadog-rum";
import { initializeDatadogLogs, setDatadogLogsUser } from "~/lib/datadog-logs";
import { initializeDatadogRUM } from "~/lib/datadog-rum";

interface DatadogProviderProps {
  children: ReactNode;
}

/**
 * Initialize DataDog RUM and Logs.
 *
 * IMPORTANT: This should be called once and as soon as possible, so that any
 * logs and errors are recorded from the very beginning.
 */
export function initializeDatadog() {
  initializeDatadogRUM();
  initializeDatadogLogs();
}

/**
 * Provider component that automatically tracks user data in DataDog RUM sessions
 * Should be rendered high up in the component tree after user authentication
 */
export const DatadogProvider = ({ children }: DatadogProviderProps) => {
  const userAttributes = useAuth();
  const { setUser } = useDatadogRUM();

  useEffect(() => {
    if (userAttributes?.user) {
      const user = userAttributes.user;

      const userData = {
        id: user.id,
        name: user.email,
        email: user.email,
        // Add teams as a custom property for better tracking
        teams: user.teams?.map((t) => t.name).join(",") || "",
      };

      // Set DataDog user context for both RUM and Logs
      setUser(userData);
      setDatadogLogsUser(userData);
    }
  }, [userAttributes?.user, setUser]);

  return <>{children}</>;
};
